import { useMemo } from 'react';
import { PlatformType } from '../types/common';
import {
  getCarouselStyleConfig,
  CarouselStyleConfig,
} from '../utils/carouselStyleConfig';
import { ProductCardVariant } from '../utils/constants';

interface UseCarouselStyleConfigProps {
  carouselType: string;
  platform: PlatformType | null;
  productCardVariant: ProductCardVariant;
}

export const useCarouselStyleConfig = ({
  carouselType,
  platform,
  productCardVariant,
}: UseCarouselStyleConfigProps): CarouselStyleConfig => {
  const styleConfig = useMemo(
    () => getCarouselStyleConfig(carouselType, platform, productCardVariant),
    [carouselType, platform, productCardVariant],
  );

  return styleConfig;
};
